export const emeaCountrySet = new Set([
  "at",
  "be",
  "ch",
  "cz",
  "de",
  "dk",
  "es",
  "fi",
  "fr",
  "gb",
  "ie",
  "it",
  "nl",
  "no",
  "pl",
  "se",
]);

/** @param {string} countryCode - Lowercase or Uppercase 2-char country code */
function getIsEMEA(countryCode) {
  const countryUpper = countryCode?.toLowerCase();
  return emeaCountrySet.has(countryUpper);
}
export default getIsEMEA;
